module.exports = __webpack_public_path__ + "static/img/5.944d3d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/ovulation/5.png
// module id = itsm
// module chunks = 1